/**
 * Stepper − / + para inputs WooCommerce `.qty`.
 * Delegado en document: funciona tras AJAX (variaciones, carrito, fragments).
 *
 * El aviso nativo del navegador con max="1" sale como «un valor menor que 1»
 * (traducción mala de «no más de 1»). Aquí se recorta al máximo y se cambia el texto.
 */

function parseBound(value, fallback) {
    const n = parseFloat(value);
    return Number.isFinite(n) ? n : fallback;
}

function readQtyMeta(input) {
    const step = parseBound(input.getAttribute('step'), 1);
    const min = parseBound(input.getAttribute('min'), 0);
    const maxAttr = input.getAttribute('max');
    const max = maxAttr === null || maxAttr === '' ? Infinity : parseBound(maxAttr, Infinity);
    return { step: step > 0 ? step : 1, min, max };
}

function formatQty(value, step) {
    const decimals = (String(step).split('.')[1] || '').length;
    return decimals ? value.toFixed(decimals) : String(value);
}

function qtyMessage(key, replacement) {
    const dict = typeof window.BASE_THEME !== 'undefined' ? window.BASE_THEME : {};
    const template = dict[key] || '';
    return template.replace('%s', String(replacement));
}

function applyQtyValidity(input) {
    const { min, max } = readQtyMeta(input);
    const value = parseBound(input.value, min);

    if (Number.isFinite(max) && value > max) {
        input.setCustomValidity(
            max === 1 ? qtyMessage('qtyMaxOne') : qtyMessage('qtyMaxN', max)
        );
        return;
    }
    if (value < min) {
        input.setCustomValidity(qtyMessage('qtyMinN', min));
        return;
    }
    input.setCustomValidity('');
}

function syncQtyButtons(input) {
    const wrap = input.closest('.quantity');
    if (!wrap) {
        return;
    }
    const { min, max } = readQtyMeta(input);
    const value = parseBound(input.value, min);
    const minus = wrap.querySelector('.qty-btn--minus');
    const plus = wrap.querySelector('.qty-btn--plus');
    if (minus) {
        minus.disabled = value <= min;
    }
    if (plus) {
        plus.disabled = value >= max;
    }
}

function clampQty(input, { emitChange = false } = {}) {
    const { min, max, step } = readQtyMeta(input);
    let value = parseBound(input.value, min);
    value = Math.min(max, Math.max(min, value));
    const formatted = formatQty(value, step);
    const changed = input.value !== formatted;
    if (changed) {
        input.value = formatted;
        if (emitChange) {
            input.dispatchEvent(new Event('input', { bubbles: true }));
            input.dispatchEvent(new Event('change', { bubbles: true }));
        }
    }
    applyQtyValidity(input);
    syncQtyButtons(input);
    return changed;
}

function setQty(input, next) {
    const { min, max, step } = readQtyMeta(input);
    let value = Math.round(next / step) * step;
    value = Math.min(max, Math.max(min, value));
    const formatted = formatQty(value, step);
    if (input.value === formatted) {
        applyQtyValidity(input);
        syncQtyButtons(input);
        return;
    }
    input.value = formatted;
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new Event('change', { bubbles: true }));
    applyQtyValidity(input);
    syncQtyButtons(input);
}

function refreshAllQty() {
    document.querySelectorAll('input.qty').forEach((input) => {
        clampQty(input);
    });
}

export function initQuantitySteppers() {
    document.addEventListener('click', (event) => {
        const btn = event.target.closest('.qty-btn');
        if (!btn || btn.disabled) {
            return;
        }
        const wrap = btn.closest('.quantity');
        const input = wrap && wrap.querySelector('input.qty');
        if (!input || input.readOnly || input.disabled) {
            return;
        }
        event.preventDefault();
        const { step } = readQtyMeta(input);
        const current = parseBound(input.value, 0);
        setQty(input, btn.classList.contains('qty-btn--plus') ? current + step : current - step);
    });

    document.addEventListener('change', (event) => {
        if (event.target.matches && event.target.matches('input.qty')) {
            clampQty(event.target, { emitChange: false });
        }
    });

    document.addEventListener(
        'submit',
        (event) => {
            const form = event.target;
            if (!form || !form.querySelectorAll) {
                return;
            }
            form.querySelectorAll('input.qty').forEach((input) => {
                clampQty(input);
            });
        },
        true
    );

    refreshAllQty();

    if (typeof window.jQuery !== 'undefined') {
        window.jQuery(document.body).on(
            'updated_cart_totals updated_wc_div found_variation wc_fragments_refreshed',
            refreshAllQty
        );
    }
}
